/* eslint-disable */
export default {
  file_types: {
    EDPAR: 'Cuentas/intervinientes',
    EDOPE: 'Operaciones',
    EDFIO: 'Partidas Fiscales',
    EDVLF: 'Valores liquidativos (FI)',
    EDVLP: 'Valores liquidativos (PP)',
    EDVLC: 'Valores liquidativos (Clases)',
    'EDOPE-FI': 'Operaciones (FI)',
    'EDFIO-FI': 'Fiscalidad (FI)',
    'EDDET-FI': 'Detalles de traspasos (FI)',
    'EDSAL-FI': 'Saldos (FI)',
    'EDOPE-PP': 'Operaciones (PP)',
    'EDFIO-PP': 'Fiscalidad (PP)',
    'EDDET-PP': 'Detalles de traspasos (PP)',
    'EDSAL-PP': 'Saldos (PP)',
    EDSOL: 'Solicitudes de Traspaso',
    FIMO: 'CNMV FIMO',
    SIMO: 'CNMV SIMO',
    IEXT: 'CNMV IEXT',
    VCLI: 'Clientes',
    VCON: 'Contratos',
    VOPE: 'Operaciones',
    VNAVP: 'NAV y patrimonio',
    VSALD: 'Saldos',
    BMFTG: 'Valores liquidativos'
  },
  errors: {
    MaxSizeError: 'Tamaño máximo sobrepasado',
    UnknownMimetypeError: 'Fichero no soportado',
    UnknownFiletypeError: 'Tipo fichero desconocido',
    DuplicatedFiletypeError: 'Tipo fichero duplicado',
    InProgressFiletypeError: 'Tipo fichero en progreso'
  },
  uploaded_files: 'Archivos subidos',
  drop_files_here: 'Arrastra aquí los archivos',
  or_upload: 'o súbelos',
  selected_files: 'archivos seleccionados',
  add_files: 'Añadir archivos',
  document_type: 'Tipo de documento',
  select_document_type: 'Seleccionar tipo de documento'
};
